/** @module csi/xml */
define([
	"dojo/_base/lang",
	"underscore",
	"src/c8-platform/utility/enum",
	"csi",
	"csi/utility/nodeUtility",
	"csi/utility/pathUtility"
], function(lang, _, { enumCreate }, csi, nodeUtility, pathUtility) {

	const {
		PATH_OP_CHILD,
		PATH_OP_INDEX,
		PATH_OP_PARENT,
		URL_PATH,

		getUrlPath,
		isUrlWithPath,
		isPathOperator,
		pathsAreSame,
		pathCreate,
		pathRemoveStep,
		pathGetSteps,
		pathGetStepOperator,
		pathGetStepOperand,
		pathHasParentStep,
	} = pathUtility;

	const {
		nodeHasAttribute
	} = nodeUtility;

	var BOOLEAN_TRUE = "true";
	var CENTRIC_CLIENT_URL = "C0_";
	var MATCHES_WILDCARD_CLIENT = "*";
	var MATCHES_WILDCARD_SERVER = "%";
	var NODE_ROLLUPS = "#Rollups";

	var _builtins = ["$CR", "$CT", "$FG", "$Name", "$PB", "$PT", "$Right", "$Type", "$URL", "$VR", "Node Crew", "Node Name", "Node Type", "__Parent__"];
	var _reURL = /^(C[0-9]+|C0_|centric:|cf:)/;
	var _reValidURL = /^(C[0-9]+|C0_|CI\/|centric:\/|cf:\/)/;
	var _reOpValue = /^(CO|NC|RE|NM|EQ|NE|IA|NI|LT|LE|GT|GE|RANGE)$/;
	var _reIsMatchValue = /(^\*)|(\*$)/;
	var _reFromMatchValue = /^\*|\*$/g;

	var _nodeProperties = {
		"FG": "Flags",
		"CT": "CreatedTime",
		"CR": "Creator",
		"PT": "PublishedTime",
		"PB": "Publisher",
		"VR": "Version"
	};

	var _nodeParameters = {
		"Flags": "FG",
		"CreatedTime": "CT",
		"Creator": "CR",
		"PublishedTime": "PT",
		"Publisher": "PB",
		"Version": "VR"
	};

	return {
		ADMIN_USER: "centric://REFLECTION/INSTANCE/User/Administrator",
		ARCHIVE_ADMIN: "Archive Administrator",
		ARCHIVE_VIEWER: "Archive Viewer",
		CONFIG_EDITOR: "Configuration Editor",
		ROLE_ADMIN: "centric://REFLECTION/INSTANCE/Group/SiteAdministrator",
		ROLE_CONFIG_VIEWER: "centric://REFLECTION/INSTANCE/Role/Configuration Viewer",
		ROLE_CONFIG_EDITOR: "centric://REFLECTION/INSTANCE/Role/Configuration Editor",
		ROLE_TEAM_MANAGER: "centric://REFLECTION/INSTANCE/Role/Team Manager",
		DEBUG_VIEWER: "centric://REFLECTION/INSTANCE/Role/Debug Viewer",

		TYPE_REPORT: "CustomReport",
		TYPE_USER: "User",
		TYPE_GROUP: "Group",
		TYPE_ROLE: "Role",
		TYPE_COMPANY_INFO: "CompanyInfo",

		PROP_CREATE_TIME: "CT",
		PROP_CREATOR: "CR",
		PROP_FLAGS: "Flags",
		PROP_PUBLISHED_BY: "PB",
		PROP_PUBLISHED_TIME: "PT",
		PROP_URL: "URL",
		PROP_VERSION: "VR",

		PROP_EXP: "Exp",
		PROP_EXP_OP: "ExpOp",
		PROP_FG: "FG",
		PROP_ID: "Id",
		PROP_KEY: "Key",
		PROP_NAME: "Name",
		PROP_TYPE: "Type",
		PROP_VALUE: "Value",
		PROP_COUNT_VALUES: "Count",

		// Request Parameters
		PROP_USERID: "UserID",
		PROP_PASSWORD: "Password",
		PROP_EMAIL: "Email",
		PROP_INDEX_FROM: "FromIndex",
		PROP_INDEX_TO: "ToIndex",
		PROP_URL_BEFORE: "BeforeURL",
		PROP_URL_FROM: "FromURL",
		PROP_URL_PARENT: "ParentURL",
		PROP_ATTR_PARENT: "ParentAttr",
		PROP_ATTR_ADD: "AddAttr",
		PROP_AGGREGATE: "Add",
		PROP_AGGREGATE_ALL: "AddAll",
		PROP_AGGREGATE_ADD: "AddURL",
		PROP_AGGREGATE_ADDS: "AddURLs",
		PROP_AGGREGATE_REMOVES: "RemoveURLs",
		PROP_SILENT: "Silent",

		// Client only operators - not recognized by server
		OP_CONTAINS: "CO",
		OP_NOT_CONTAINS: "NC",

		// Comparison Operators
		OP_EXISTS: "EX",
		OP_NOT_EXISTS: "NX",
		OP_NOT_MATCHES: "NM",
		OP_MATCHES: "RE",
		OP_EQUALS: "EQ",
		OP_NOT_EQUALS: "NE",
		OP_RANGE: "RANGE",
		OP_WITHIN: "WITHIN",
		OP_LESS_THAN: "LT",
		OP_LESS_EQUAL: "LE",
		OP_GREATER_THAN: "GT",
		OP_GREATER_EQUAL: "GE",
		OP_NULL: "NL",
		OP_NOT_NULL: "NN",
		OP_OR_EQUALS: "OR_EQ",
		OP_BIT_0: "B0",
		OP_BIT_1: "B1",
		OP_BIT_ALL: "BA",
		OP_EMPTY_STRING: "US",

		OP_BLANKS: "U",
		OP_NON_BLANKS: "F",

		OP_BLANK_DEFAULT: "S",
		OP_BLANK_ENUM: "E",
		OP_BLANK_LOCALIZED: "L",
		OP_BLANK_TIME: "T",

		PATH_OP_CHILD,
		PATH_OP_INDEX,
		PATH_OP_PARENT,
		URL_PATH,

		RIGHT_NONE: "None",
		RIGHT_READ: "Read",
		RIGHT_WRITE: "Write",
		RIGHT_ADMIN: "Admin",

		ATTR_BOOLEAN: "boolean",
		ATTR_BOOLEANMAP: "booleanmap",
		ATTR_BOOLEANVECTOR: "booleanvector",
		ATTR_CNL: "cnl",
		ATTR_CNLLIST: "cnllist",
		ATTR_DOUBLE: "double",
		ATTR_DOUBLEVECTOR: "doublevector",
		ATTR_ENUM: "enum",
		ATTR_ENUMLIST: "enumlist",
		ATTR_ENUMMAP: "enummap",
		ATTR_ENUMSET: "enumset",
		ATTR_ERROR: "error",	// occurs when rollup expression has error during evaluation
		ATTR_EXPRESSION: "expression",
		ATTR_FLOAT: "float",
		ATTR_INTEGER: "integer",
		ATTR_INTEGERVECTOR: "integervector",
		ATTR_INT64: "int64",
		ATTR_INT64LIST: "int64list",
		ATTR_LONG: "long",
		ATTR_REF: "ref",
		ATTR_REFLIST: "reflist",
		ATTR_REFMAP: "refmap",
		ATTR_REFSET: "refset",
		ATTR_REFVECTOR: "refvector",
		ATTR_STRING: "string",
		ATTR_STRINGLIST: "stringlist",
		ATTR_STRINGMAP: "stringmap",
		ATTR_STRINGSET: "stringset",
		ATTR_STRINGVECTOR: "stringvector",
		ATTR_TIME: "time",
		ATTR_URL: "url",
		ATTR_URLLIST: "urllist",
		ATTR_URLMAP: "urlmap",
		ATTR_LIST: "list",
		ATTR_MAP: "map",
		ATTR_VECTOR: "vector",
		ATTR_SET: "set",

		ATTR_NAME: "Node Name",
		ATTR_TYPE: "Node Type",
		ATTR_CREW: "Node Crew",
		ATTR_LOCALIZED_NAME: "LocalizedName",
		ATTR_PARENT: "__Parent__",
		ATTR_CLIENT_SOURCE_URL: "__ClientSource__",

		ATTR_COMMENT_SUFFIX: ".Comment",
		ATTR_COMMENT_COLOR_SUFFIX: ".Color",
		ATTR_FILENAME_SUFFIX: ".File",

		NODE_FLAG_NOEDIT: 0x1,
		NODE_FLAG_NODELETE: 0x2,
		NODE_FLAG_TEMPLATE: 0x20,
		NODE_FLAG_FROZEN: 0x4,
		NODE_FLAG_REFERENCED_BY_ARCHIVE_NODES: 0x80,
		NODE_FLAG_ARCHIVED_NODE: 0x2000,

		ATTR_FLAG_NOEDIT: 0x1,
		ATTR_FLAG_OUT_OF_SYNC: 0x200,
		ATTR_FLAG_EVAL_EXPRESSION: 0x4000,
		ATTR_FLAG_ONE_TIME_EXPRESSION: 0x8000,
		ATTR_FLAG_ONE_TIME_ROLLUP: 0x20000,
		ATTR_FLAG_MODIFIED_BY_CLIENT: 0x40000,
		ATTR_FLAG_HAS_EXPRESSION: 0x100000,
		ATTR_FLAG_DISABLE_EXPRESSION: 0x400000,
		ATTR_FLAG_ONE_TIME_FREEZE_ROLLUP: 0x800000,
		ATTR_FLAG_CALCULATE_WHEN_FROZEN: 0x1000000,
		ATTR_FLAG_FORM_ONLY: 0x4000000,

		// reflection flags
		ATTR_RFLAG_OPTIONAL: 0x08,
		ATTR_RFLAG_REQUIRED: 0x10,
		ATTR_RFLAG_NOTIFY: 0x20,
		ATTR_RFLAG_DISABLE_DRAG_EDIT: 0x80,
		ATTR_RFLAG_DISABLE_CLIENT_EXPR: 0x100,
		ATTR_RFLAG_VIABLE_MATRIX: 0x400,
		ATTR_RFLAG_HIDDEN: 0x800,
		ATTR_RFLAG_COMMENT_RESTRICTED: 0x1000,
		ATTR_RFLAG_AUTOFILL_DEPENDENT_ENUM: 0x8000,
		ATTR_RFLAG_REVERSE_COMPOSITE: 0x010000,
		ATTR_RFLAG_REVERSE_RELATION: 0x020000,
		ATTR_RFLAG_REVERSE_RELATION_DELAYED: 0x040000,
		ATTR_RFLAG_PARTICIPATE_IN_ACTION: 0x200000,
		ATTR_RFLAG_DELAYED_SEARCH: 0x400000,
		ATTR_RFLAG_FORM_EDITING: 0x1000000,
		ATTR_RFLAG_CREATE_EDITING: 0x2000000,
		ATTR_RFLAG_TABLE_VIEW_EDITING: 0x3000000,
		ATTR_RFLAG_DISABLE_EDITING: 0x7000000,
		ATTR_RFLAG_EDITING_MASK: 0x7000000,

		NODE_FLAGS_READONLY: [0x1, 0x4],
		ATTR_FLAGS_READONLY: [0x1],

		// filter constants
		FILTER_TAG_ACCESS: "Access",
		FILTER_TAG_AND: "AND",
		FILTER_TAG_ATTR: "Attribute",
		FILTER_TAG_NODE: "Node",
		FILTER_TAG_NOT: "NOT",
		FILTER_TAG_OR: "OR",
		FILTER_TAG_SORT_ATTR: "OrderByAttribute",
		FILTER_TAG_SORT_INDEX: "OrderByIndex",
		FILTER_TAG_SORT_NODE: "OrderByNode",

		FILTER_PROP_DIMENSION: "Dimension",
		FILTER_PROP_FLAG: "Flag",
		FILTER_PROP_ID: "Id",
		FILTER_PROP_INDEX: "Index",
		FILTER_PROP_OP: "Op",
		FILTER_PROP_PARAMETER: "Parameter",
		FILTER_PROP_PATH: "Path",
		FILTER_PROP_RIGHT: "Right",

		FILTER_DVALUE: "DValue",
		FILTER_NVALUE: "NValue",
		FILTER_RVALUE: "RValue",
		FILTER_SVALUE: "SValue",
		FILTER_VALUE: "Value",

		FILTER_LOCALIZED_NAME: "LocalizedName*",

		VALUE_BLANK: "FILTER_BLANKS",
		VALUE_NONBLANK: "FILTER_NON_BLANKS",
		VALUE_NEWLY_CREATED: "__NEWLY_CREATED",

		// sort constants
		SORT_SEQUENCE: "Sequence",
		SORT_DESC: "DESC",

		// regular expressions
		RE_CONTAINER: /(list|map|set|vector)$/,
		RE_INTEGER: /(integer|int64)$/,
		RE_MAP: /map$/,
		RE_NUMERIC: /(double|float|integer|int64|long)$/,
		RE_REF: /^ref/,
		RE_WEB: /^(https:\/\/|http:\/\/|ftp:\/\/)/,

		escapeMatchValue: function(/*String*/s) {
			// summary: escape any occurrences of matches wildcard
			return s.replace(/%/g, "\\%");
		},

		escapeStringForRegExp: function(/*String*/s) {
			// summary: return string with all regular expression special characters escaped
			return s.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
		},

		/**
		 * Return string to use as query value for match filter
		 * @param {string} s
		 * @return {string|null}
		 */
		getClientMatchValue: function(s) {
			// if string is empty, then no need to apply query since it will match anything
			return s ? (MATCHES_WILDCARD_CLIENT + s + MATCHES_WILDCARD_CLIENT) : null;
		},

		getServerMatchValue: function(/*String*/s) {
			// summary: if value does not already contain wildcard, then add it
			if (!s) {
				return MATCHES_WILDCARD_SERVER;
			} else if (s.replace(/\\%/g, "").indexOf(MATCHES_WILDCARD_SERVER) == -1) {
				// javascript RegExp does not support negative lookbehind, so remove escaped wildcards before looking for one
				return MATCHES_WILDCARD_SERVER + s + MATCHES_WILDCARD_SERVER;
			}

			return s;
		},

		getRegExpForMatchValue: function(/*String*/s) {
			// summary: convert filter value into regular expression - value will already contain wildcards (%) where desired
			s = this.escapeStringForRegExp(s);

			if (s.charAt(0) == MATCHES_WILDCARD_SERVER) {
				s = s.substring(1);
			} else {
				s = "^" + s;
			}

			var n = s.length - 1;

			if (s.charAt(n) == MATCHES_WILDCARD_SERVER) {
				s = s.substr(0, n);
			} else {
				s += "$";
			}

			return new RegExp(s, "i");
		},

		getClientNodeUrl: function(/*String?*/suffix) {
			return _.uniqueId(CENTRIC_CLIENT_URL + (suffix || ""));
		},


		getUrlPathObject: function(/*String*/url) {
			var a = url.split(URL_PATH);

			return {
				url: a[0],
				path: a[1] ? unescape(a[1]) : null
			};
		},

		/**
		 * Return true is given url is a client url, and matches any given suffix
		 * @param {string} url
		 * @param {string} [suffix]
		 * @return {boolean}
		 */
		isClientUrl: function(url, suffix) {
			return url && !url.indexOf(CENTRIC_CLIENT_URL + (suffix || ""));
		},

		isEmptyURL: function(url) {
			return !url || url == csi.EMPTY_URL;
		},

		isURL: function(url) {
			return _reURL.test(url);
		},

		isValidURL: function(url) {
			return _reValidURL.test(url);
		},

		/**
		 * Return true if two values are the same
		 * @param {any} value
		 * @param {any} otherValue
		 * @return {boolean}
		 */
		isSameValue: function(value, otherValue) {
			if (_.isArray(value) && _.isArray(otherValue)) {
				// handle array compare
				return _.isEqual([].concat(value).sort(), [].concat(otherValue).sort());
			} else if (_.isObject(value) && _.isObject(otherValue)) {
				// handle object compare
				return _.isEqual(value, otherValue);
			} else {
				return value === otherValue;
			}
		},

		urlEquals: function(url1, url2) {
			url1 = url1 || csi.EMPTY_URL;
			url2 = url2 || csi.EMPTY_URL;
			return url1 == url2;
		},

		idGetComment: function(id) {
			return id + this.ATTR_COMMENT_SUFFIX;
		},

		idGetCommentColor: function(id) {
			return id + this.ATTR_COMMENT_COLOR_SUFFIX;
		},

		idGetFile: function(id) {
			return id + this.ATTR_FILENAME_SUFFIX;
		},

		queryKey: function(/*String?*/id, /*String?*/index, /*String?*/path, /*String?*/prop) {
			return (prop ? "$" + prop : id) + ((index == null) ? "" : "/" + index) + (path ? ":" + path : "");
		},

		splitQueryKey: function(/*String*/queryKey) {
			var obj = {};
			var n = queryKey.indexOf(":");
			var idAndIndex = (n > 0) ? queryKey.substring(0, n) : queryKey;
			var indexSplit = idAndIndex.split("/");
			var propOrId = indexSplit[0];

			if (n > 0) {
				obj.path = queryKey.substring(n + 1);
			}

			if (indexSplit.length == 2) {
				obj.index = indexSplit[1];
			}

			if (propOrId[0] == "$") {
				obj.prop = propOrId.substring(1);
			} else {
				obj.id = propOrId;
			}

			return obj;
		},

		queryIsMatchValue: function(/*String*/v) {
			return _reIsMatchValue.test(v);
		},

		queryFromMatchValue: function(/*String*/v) {
			return v.replace(_reFromMatchValue, "");
		},

		queryToServerMatchValue: function(/*String*/v) {
			return v.replace(/^\*/, MATCHES_WILDCARD_SERVER).replace(/\*$/, MATCHES_WILDCARD_SERVER);
		},

		valueHasFlag: function(value, nBit) {
			return (value & nBit) != 0;
		},

		/** It is valid when HAS elements and if it is a container type. */
		isContainerValueValid(value, type) {
			if (this.attributeTypeIsContainer(type)) {
				const isArrayValid = _.isArray(value) && !!value.length;
				const isObjectValid = _.isObject(value) && !_.isEmpty(value);
				const isCollectionValid = _.isObject(value) && value.size > 0;
				return !!value && (isArrayValid || isObjectValid || isCollectionValid);
			}

			return false;
		},

		valueIsValid: function(value, type) {
			if (this.attributeTypeIsContainer(type)) {
				return this.isContainerValueValid(value, type);
			} else switch (type) {
				case this.ATTR_BOOLEAN: return !!value;
				case this.ATTR_REF: return this.isValidURL(value);
				case this.ATTR_URL: return value && (value != "cf:");
				case this.ATTR_TIME: return value > 0;

				case this.ATTR_ENUM: value = (typeof value === "string") ? value.split(':')[1] : null; return !!value;
				case this.ATTR_STRING: return !!value;
			}

			// numeric attributes are always valid???

			return true;
		},

		valueIsStringTrue: function(/*String*/value) {
			// summary: if value is from XML
			return value == BOOLEAN_TRUE;
		},

		valuePassesFilter: function(/*String*/type, /*Any*/value, /*Any*/filterValue) {
			// summary: handle special case if filterValue is VALUE_BLANK
			if (filterValue == this.VALUE_BLANK) {
				if (type == this.ATTR_ENUM) {
					value = this.enumGetText(value);
				}

				return (value === "") || (value == null);
			}

			return value === filterValue;
		},

		enumGetId: function(value) {
			return value ? value.split(":")[0] : "";
		},

		enumGetText: function(value) {
			var n = value ? value.indexOf(":") : 0;
			return (n > 0) ? value.substr(n + 1) : "";
		},

		enumCreate: function(idList, idValue) {
			return enumCreate(idList, idValue);
		},

		/**
		 * Return value from filter - protect against this function being called for XML text nodes
		 * @param {XMLNode} xn
		 * @param {string} [prop] - property storing value; if not provided, then it will be determined automatically
		 * @return {string|number|null}
		 */
		filterGetValue: function(xn, prop) {
			if (!xn.getAttribute) {
				return null;
			}

			if (prop = prop || this.filterGetValueProperty(xn)) {
				const value = xn.getAttribute(prop);

				if (value != null) {
					return (prop == this.FILTER_DVALUE) ? Number(value) : value.replace(/\&#xA;/g, "\n");
				}
			}

			return null;
		},

		/**
		 * Return property used to store filter value (Value, DValue, NValue, RValue, SValue)
		 * @param {XMLNode} xn
		 * @return {string}
		 */
		filterGetValueProperty: function(xn) {
			var prop;

			if (xn.getAttribute) {
				if (xn.getAttribute(this.FILTER_SVALUE) != null) {
					prop = this.FILTER_SVALUE;
				} else if (xn.getAttribute(this.FILTER_RVALUE) != null) {
					prop = this.FILTER_RVALUE;
				} else if (xn.getAttribute(this.FILTER_DVALUE) != null) {
					prop = this.FILTER_DVALUE;
				} else if (xn.getAttribute(this.FILTER_VALUE) != null) {
					prop = this.FILTER_VALUE;
				} else if (xn.getAttribute(this.FILTER_NVALUE) != null) {
					prop = this.FILTER_NVALUE;
				}
			}

			return prop;
		},

		/**
		 * Return true if filter value contains an expression
		 * @param {XMLNode} xn
		 * @return {boolean}
		 */
		filterHasExpression: function(xn) {
			// if value has "(", then assume it is an expression due to a function call
			var prop = this.filterGetValueProperty(xn);
			if (prop) {
				var s = xn.getAttribute(prop);
				return typeof s === 'string' ? (s.indexOf("(") > 0) : false;
			}

			return false;
		},

		isNodeProperty: function(prop) {
			return !!this.propertyType(prop);
		},

		opHasValue: function(op) {
			return _reOpValue.test(op);
		},

		filterParameterToProperty: function(param) {
			return _nodeParameters[param] || param;
		},

		propertyToFilterParameter: function(prop) {
			return _nodeProperties[prop] || prop;
		},

		propertyType: function(prop) {
			// determine type of value for each property
			switch (prop) {
				case this.PROP_NAME:
				case this.PROP_EXP:
				case this.PROP_ID:
				case this.PROP_TYPE: return this.ATTR_STRING;

				case this.PROP_CREATOR:
				case this.PROP_PUBLISHED_BY: return this.ATTR_REF;

				case this.PROP_CREATE_TIME:
				case this.PROP_PUBLISHED_TIME: return this.ATTR_TIME;

				case this.PROP_FG:
				case this.PROP_VERSION: return this.ATTR_INTEGER;

				case this.PROP_URL: return this.ATTR_CNL;
			}
		},

		rightIsMore: function(r1, r2) {
			// Return values:
			//	-1: r1 is superseded by r2
			//	 0: r1 supersedes r2
			//	 1: r1 is additional right to r2

			if ((r1 == r2) || !r1 || r2 == this.RIGHT_NONE)
				return -1;
			else if (!r2)
				return 0;

			switch (r1) {
				case this.RIGHT_READ: return -1;
				case this.RIGHT_WRITE: return (r2 == this.RIGHT_READ) ? 1 : (r2 == this.RIGHT_ADMIN) ? -1 : 0;
				case this.RIGHT_ADMIN: return ((r2 == this.RIGHT_READ) || (r2 == this.RIGHT_WRITE)) ? 0 : 1;
			}

			// if there are special rights, then return true
			return 1;
		},

		attributeTypeGetBase: function(type) {
			// ALTERNATIVE: c8-platform/type/value#getPrimitiveValueType
			// if container type, then return type of contained items
			var a = (typeof type === "string") ? type.split(this.RE_CONTAINER) : null;

			return (a && a[0] && (a[0] != type)) ? a[0] : null;
		},

		attributeTypeGetDefaultValue(type, format) {
			var base = this.attributeTypeGetBase(type);
			if (base) {
				return this.attributeTypeIsMap(type) ? {} : [];
			}

			switch (type) {
				case this.ATTR_BOOLEAN: return false;
				case this.ATTR_STRING: return "";
				case this.ATTR_ENUM: return format ? (format + ":") : "";

				case this.ATTR_CNL:
				case this.ATTR_REF:
				case this.ATTR_URL: return csi.EMPTY_URL;
			}

			return 0;
		},

		attributeTypeIsContainer: function(type) {
			return type && this.RE_CONTAINER.test(type);
		},

		attributeTypeIsInteger: function(type) {
			return type && this.RE_INTEGER.test(type);
		},

		attributeTypeIsMap: function(type) {
			return type && this.RE_MAP.test(type);
		},

		attributeTypeIsNumeric: function(type) {
			return type && this.RE_NUMERIC.test(type);
		},

		attributeTypeIsRef: function(type) {
			return type && this.RE_REF.test(type);
		},

		/**
		 * Combine type and subtype into single string
		 * @param {string} type
		 * @param {string} [subtype]
		 * @return {string}
		 */
		combineNodeTypeAndSubtype: function(type, subtype) {
			const suffix = subtype ? `/${subtype}` : "";
			return `${type}${suffix}`;
		},

		nodeApplyRollups: function(node, nodeSource) {
			// summary: transfer rollup values from source node to new node
			_.each(nodeSource[NODE_ROLLUPS], function(value, id) {
				// if expression was disabled since last evaluation, don’t apply.
				if (node[id] != value && this.nodeAttributeHasExpression(node, id)) {
					this.nodeAttributeSetValue(node, id, nodeSource[id], true);
				}
			}, this);
		},

		nodeAttributeContainsValue: function(node, idAttr, valueToCheck) {
			var value = node[idAttr];
			if (value == null) {
				return false;
			} else if (_.isString(value)) {
				return value == valueToCheck;
			} else if (_.isArray(value)) {
				return _.contains(value, valueToCheck);
			} else {
				for (var k in value) {
					if (value[k] == valueToCheck)
						return true;
				}
			}
			return false;
		},

		nodeAttributeGetFlags: function(node, id) {
			var attr = this._nodeGetAttribute(node, id);
			return attr ? attr.FG : null;
		},

		nodeAttributeGetKeyValue: function(node, id, key) {
			var v = node ? node[id] : null;
			if (v && (key != null)) {
				v = v[key];
			}

			return v;
		},

		nodeAttributeGetType: function(node, id) {
			var attr = this._nodeGetAttribute(node, id);
			return attr ? attr.Type : null;
		},

		nodeGetAllAttributes: function(/*Node*/node, /*Boolean*/bValuesOnly) {
			// summary: return object containing all attributes (other than those that are built-in)
			var obj = _.omit(node, _builtins);

			if (bValuesOnly) {
				delete obj.$attrs;
			}

			return obj;
		},

		nodeGetAttributeValue: function(node, id) {
			// FIX: rename to nodeAttributeGetValue, or just use node[id]
			return node ? node[id] : null;
		},

		nodeAttributeGetValues: function(node, id, omitValue) {
			var a;
			var value = node[id];
			if (value) {
				if (value instanceof Array) {
					a = value;
				} else if (_.isObject(value)) {
					a = csi.objectValues(value);
				} else if (value != omitValue) {
					return [value];
				}

				if (a && omitValue) {
					a = _.filter(a, function(v) {return v != omitValue;});
				}
			}

			return a || [];
		},

		nodeAttributeHasExpression: function(node, id, bPerpetual) {
			var fg = this.nodeAttributeGetFlags(node, id);

			return this.valueHasFlag(fg, this.ATTR_FLAG_HAS_EXPRESSION) &&
				!this.valueHasFlag(fg, this.ATTR_FLAG_DISABLE_EXPRESSION) &&
				(!bPerpetual || (!this.valueHasFlag(fg, this.ATTR_FLAG_ONE_TIME_EXPRESSION) && !this.valueHasFlag(fg, this.ATTR_FLAG_ONE_TIME_ROLLUP)));
		},

		nodeAttributeHasFlag: function(node, id, flag) {
			var fg = this.nodeAttributeGetFlags(node, id);
			return fg ? this.valueHasFlag(fg, flag) : false;
		},

		nodeAttributeWasEvaluated: function(node, id) {
			var obj = node[NODE_ROLLUPS];
			return obj && (obj[id] != null);
		},

		nodeAttributeIsReadOnly: function(node, id) {
			return this.nodeAttributeHasFlag(node, id, this.ATTR_FLAG_NOEDIT);
		},

		nodeAttributeIsValueValid: function(node, id) {
			var type = this.nodeAttributeGetType(node, id);
			return type ? this.valueIsValid(node[id], type) : false;
		},

		nodeAttributeSetFlags: function(node, id, fg) {
			var attr = this._nodeGetAttribute(node, id);
			if (attr) attr.FG = fg;
		},

		nodeAttributeSetType: function(node, id, type) {
			var attr = this._nodeGetAttribute(node, id);
			if (attr) attr.Type = type;
		},

		nodeAttributeSetValue: function(node, id, value, bEvaluated) {
			if (id == this.ATTR_NAME) {
				node.$Name = value;
			} else if (value != null) {
				var type = this.nodeAttributeGetType(node, id);

				if (this.attributeTypeIsNumeric(type) || (type == this.ATTR_TIME)) {
					value = Number(value);
				}
			}

			// track differences between server value for attribute and client value after evaluating expression
			var rollups = node[NODE_ROLLUPS];

			if (bEvaluated) {
				rollups = node[NODE_ROLLUPS] = rollups || {};
				rollups[id] = value;
			} else if (rollups) {
				// setting to non-evaluated value only happens when changing server value as well
				delete rollups[id];
			}

			// finally, set new attribute value
			node[id] = value;
		},

		nodeCanBeDeleted: function(node) {
			return this.nodeHasRight(node, this.RIGHT_ADMIN) && !this.nodeHasFlag(node, this.NODE_FLAG_NODELETE);
		},

		nodeCopy: function(node) {
			// summary: clone node - since the $attrs objects point back to node, need to work around
			// FIX: for now, share attribute arrays - this is currently only used for attribute values
			var attrs = node.$attrs;
			node.$attrs = null;
			var n = lang.clone(node);
			n.$attrs = node.$attrs = attrs;
			return n;
		},

		nodeCreateClientNode: function(url, type, name, flags, nameFlags) {
			var node = {};

			name = name || "";
			node['$' + this.PROP_URL] = url || this.getClientNodeUrl();
			node['$' + this.PROP_TYPE] = type || "Node";
			node['$' + this.PROP_NAME] = name;
			node['$' + this.PROP_FG] = flags || 0;
			node.$Right = {Read: 1, Write: 1, Admin: 1};
			node.$attrs = {};

			if (nameFlags == null) {
				nameFlags = this.ATTR_FLAG_NOEDIT;
			}

			// create type attribute to ensure node is valid
			this.nodeCreateClientAttr(node, this.ATTR_NAME, this.ATTR_STRING, name, nameFlags);
			this.nodeCreateClientAttr(node, this.ATTR_TYPE, this.ATTR_STRING, type, 1);

			return node;
		},

		nodeCreateClientAttr: function(node, id, type, value, flags) {
			var attr = this._nodeGetAttribute(node, id);
			if (!attr) {
				attr = {Id: id, parentNode: node};
				node.$attrs[id] = attr;
			}

			attr[this.PROP_FG] = Number(flags) || attr[this.PROP_FG] || 0;
			attr[this.PROP_TYPE] = type;
			attr[this.PROP_VALUE] = value;

			this.nodeAttributeSetValue(node, id, value);

			return node;
		},

		nodeGetCrew: function(node) {
			return node ? node[this.ATTR_CREW] : null;
		},

		nodeGetName: function(node) {
			return node ? node.$Name : null;
		},

		nodeGetProperty: function(node, prop) {
			return node ? node["$" + prop] : null;
		},

		nodeGetSysID: function(node) {
			return node ? node.SysID : null;
		},

		nodeGetType: function(node) {
			return node ? node.$Type : null;
		},

		nodeGetURL: function(node) {
			return node ? node.$URL : null;
		},

		/**
		 * 
		 * @param {Node} node 
		 * @param {string} right 
		 * @param {string?} idAttr 
		 * @param {Number[]?} nodeFlags 
		 * @param {Number[]?} attrFlags 
		 * @returns 
		 */
		nodeHasAccess: function(node, right, idAttr, nodeFlags, attrFlags) {
			// check for access to node
			if (!this.nodeHasRight(node, right)) {
				return false;
			}

			// check to see if node is read-only - if so then no reason to continue
			if (node && (this.rightIsMore(right, this.RIGHT_READ) >= 0)) {
				if (_.some(nodeFlags || this.NODE_FLAGS_READONLY, function(fg) {
					return this.valueHasFlag(node.$FG, fg);
				}, this)) {
					return false;
				}

				if (idAttr) {
					// checking to see if attribute is editable
					var attr = this._nodeGetAttribute(node, idAttr);
					if (attr) {
						return _.every(attrFlags || this.ATTR_FLAGS_READONLY, function(fg) {
							return !this.valueHasFlag(attr.FG, fg);
						}, this);
					} else {
						// if attribute does not exist, then action not possible on it
						return false;
					}
				}
			}

			return true;
		},

		nodeHasAttribute,

		nodeHasFlag: function(node, flag) {
			return node ? this.valueHasFlag(node.$FG, flag) : false;
		},

		nodeHasRight: function(node, right) {
			// return true if node has right or if node is valid and right is not specified
			if (node) {
				if (right) {
					return node.$Right ? !!node.$Right[right] : false;
				} else {
					return true;
				}
			}

			// if the node is not valid, still return valid if right is not valid
			return !right;
		},

		nodeIsFrozen: function(node) {
			return this.nodeHasFlag(node, this.NODE_FLAG_FROZEN);
		},

		nodeIsArchived: function(node) {
			return this.nodeHasFlag(node, this.NODE_FLAG_ARCHIVED_NODE);
		},

		nodeSetFlags: function(node, flags) {
			if (node) {
				node.$FG = flags;
			}
		},

		nodeSetName: function(node, name) {
			if (node) {
				node.$Name = node[this.ATTR_NAME] = name;
			}
		},

		isPathOperator,
		getUrlPath,
		isUrlWithPath,
		pathsAreSame,
		pathCreate,
		pathGetSteps,
		pathGetStepOperator,
		pathGetStepOperand,
		pathHasParentStep,
		pathRemoveStep,

		// Deprecated
		path: pathCreate,
		pathAddStep: pathCreate,

		policyGetName: function(policy) {
			return policy ? policy.Name : null;
		},

		policyGetUMEntry: function(policy) {
			return policy ? policy.UMEntry : null;
		},

		sortNodes: function(nodes, idAttr) {
			return csi.sort(nodes, idAttr || "$Name");
		},

		e: function(doc, tag, parent) {
			var e = doc.createElement(tag);
			parent.appendChild(e);
			return e;
		},

		removeChildren: function(/*XMLNode*/e) {
			if (e) {
				while (e.firstChild)
					e.removeChild(e.firstChild);
			}
		},

		_nodeGetAttribute: function(node, id) {
			if (!node || !node.$attrs)
				return null;

			var attr = node.$attrs[id];
			if (attr == null) {
				// may be we have a value but don't have an additional info?
				// In this case, create an empty info element and assign it back into $attrs object
				if (node[id] === undefined)
					return null;

				node.$attrs[id] = attr = {};
			}

			// add missing common values
			if (attr.FG === undefined) {
				if (id == this.ATTR_TYPE)
					attr.FG = 0x15;
				else if (id == this.ATTR_PARENT) {
					attr.FG = 0x5;
					attr.Type = this.ATTR_REF;
				} else {
					attr.FG = 0;
				}
			}

			if (attr.Type === undefined) {
				attr.Type = (id == this.ATTR_CREW) ? this.ATTR_REF : this.ATTR_STRING;
			}

			return attr;
		}
	};
});